import { render } from "./CriterionItem.vue?vue&type=template&id=a7499608"
import script from "./CriterionItem.vue?vue&type=script&lang=js"
export * from "./CriterionItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__